if (!customElements.get('slider-hero')) {
  class SliderHero extends HTMLElement {
    selectors = {
      clip: '[data-clip]',
      buttons: '[data-buttons]',
      pagination: '[data-pagination]',
    };

    config = {
      slidesPerView: 'auto',
      speed: 500,
    };

    constructor() {
      super();

      this.clip = this.querySelector(this.selectors.clip);
      this.buttons = this.querySelector(this.selectors.buttons);
      this.pagination = this.querySelector(this.selectors.pagination);
      this.swiperInstance = null;
    }

    connectedCallback() {
      this.initSwiper();
    }

    disconnectedCallback() {
      this.destroySwiper();
    }

    initSwiper() {
      const { items, spacing } = this.dataset;

      this.config = Object.assign(this.config, {
        slidesPerView: items ? parseInt(items) : 'auto',
        spaceBetween: spacing ? parseInt(spacing) : 0,
        on: {
          init: (instance) => {
            if (instance.slides.length > instance.params.slidesPerView) {
              this.classList.add('has-slides');
            }
          },
        },
      });

      if (this.hasAttribute('data-time-between-slides')) {
        this.config.loop = true;
        this.config.autoplay = {
          delay: Number(this.getAttribute('data-time-between-slides')),
        };
      }

      if (this.buttons) {
        this.config = Object.assign(this.config, {
          navigation: {
            prevEl: this.buttons.children[0],
            nextEl: this.buttons.children[1],
          },
        });
      }

      if (this.pagination) {
        this.config = Object.assign(this.config, {
          pagination: {
            el: this.pagination,
            clickable: true,
          },
        });
      }

      this.swiperInstance = new Swiper(this.clip, this.config);
    }

    destroySwiper() {
      this.swiperInstance?.destroy();
    }
  }

  customElements.define('slider-hero', SliderHero);
}
